<template>
    <div class="full-w">
        <div class="plat-list mt10 mb10">
            <el-button :type="curPlat==plat.name?'primary':''" v-for="plat in platList" :key="plat.name" @click="changePlat(plat)">{{plat.displayName}}</el-button>
        </div>
        <div class="filter-bar">
            <el-row>
                <el-col :span="2">
                    <el-button type="primary" @click="showAddModal">新增爬虫账户</el-button>
                </el-col>
                <el-col :span="21">
                    <el-form :inline="true" @submit.native.prevent="submitSearch">

                    </el-form>
                </el-col>
            </el-row>
        </div>
        <div class="data-list over-hide">
            <el-row :gutter="20">
                <el-col class=" mt20"  :xl="6" :lg="8" :md="12" v-for="n in 12" :key="n">
                    <el-card class="plat-card relative" shadow="hover">
                        <el-button type="success" size="mini" round class="status-button">正常</el-button>
                        <h4 class="company-name">玩咖欢聚文化传媒（海南）有限公司</h4>
                        <p class="account-name">huaweiyzm01@gm825.com</p>
                        <div class="notice-setting mt10 mb10">
                            <span class="label-text">通知人：</span>王跃娇、王跃娇、王跃娇、王跃娇、王跃娇、王跃娇、王跃娇、王跃娇、王跃娇、王跃娇、王跃娇、王跃娇
                        </div>
                        <p class="note-text mt10 relative" :class="isEditNote?'':'ellipsis pr30'">
                            <span class="label-text">备注：</span>
                            <el-input v-if="isEditNote" v-model="noteText" @blur="isEditNote = !isEditNote" class="inline-block edit-input word-limit-input"  maxlength="30" show-word-limit placeholder="请输入内容"></el-input>
                            <span v-else style="line-height: 32px;">{{noteText}}</span>



                            <span v-if="!isEditNote" class="note-edit-icon pointer" @click="isEditNote = !isEditNote">
                                <i class="el-icon-edit-outline"></i>
                            </span>
                        </p>
                        <div class="tool-bar mt10">
                            <el-button type="primary" size="mini" plain>修改密码</el-button>
                            <el-button type="primary" size="mini" plain>修改通知人</el-button>
                            <el-button type="danger" size="mini" class="fr" plain>停用</el-button>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div class="page-bar tac mt20">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.pn"
                :page-sizes="[12, 24,48]"
                :pager-count="5"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCnt">
            </el-pagination>
        </div>

        <PlatAccountModal ref="platAccountModal" :modal-data="actionAccount"/>
    </div>
</template>

<script>
    import PlatAccountModal from '../modal/platAccountModal';


    export default {
        name: "agentPage",
        components:{
            PlatAccountModal,
        },
        data(){
            return {
                dataLoading: false,
                queryData: {
                    pn: 1,
                    rn: 12,
                },
                tempQuery: {
                },
                dataList: [],
                totalCnt: 0,
                platList:[
                    {
                        name:'oppo',
                        displayName:'OPPO',
                        code:2,
                    },
                    {
                        name:'huawei',
                        displayName:'华为',
                        code:3,
                    },
                ],
                curPlat:'oppo',
                isEditNote:false,
                noteText:'这是备注信息这是备注信息这是备注信息这是备注信息这是备注信息这是备注信息这是备注信息',
                actionAccount:{
                    title:'新增爬虫账户',

                },
            }
        },
        methods:{
            changePlat(plat){
                this.curPlat = plat.name;
            },
            submitSearch(){
                console.log('submitSearch');
            },
            handleSizeChange(val) {
                this.queryData.rn= val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList();
            },
            showAddModal(){
                console.log('showAddModal');
                this.$refs.platAccountModal.showModal();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .grid-content{
        width: 100%;
        height: 100px;
        background-color: #ccc;
    }

    .plat-card{
        border-color: #dcdee2;
    }
    .status-button{
        position: absolute;
        right: 20px;
        top: 20px;
        padding:3px 8px;
    }
    .notice-setting{
        height: 50px;
    }
    .note-text,.account-name,.label-text{
        color: #797979;
    }
    .note-text{
        /*padding-right: 30px;*/
        padding-left: 36px;
        .label-text{
            position: absolute;
            left: 0;
            top: 5px;
        }
    }
    .note-edit-icon {
        position: absolute;
        right: 0;
        top: 6px;
        color:#66b1ff;
        font-size: 16px;
    }
    .edit-input{
        /*margin-right: 0;*/
    }

    ::v-deep .word-limit-input input{
        padding-right: 44px;
    }
</style>
